import { apiClient } from '@/infrastructure/api'
import { BillingApi, GetInvoiceFileURLFileEnum } from '@itsrever/rever-api'

const billingApi = new BillingApi(undefined, undefined, apiClient)

export async function getInvoices(ecommerceId: string) {
  const response = await billingApi.getInvoices({ ecommerceId })
  return response.data
}

export async function getInvoiceFileURL(
  ecommerceId: string,
  invoiceId: string,
  file: GetInvoiceFileURLFileEnum
) {
  const response = await billingApi.getInvoiceFileURL({
    ecommerceId,
    invoiceId,
    file
  })
  return response.data
}

export async function getInvoicingPortalURL(ecommerceId: string) {
  const response = await billingApi.getInvoicingPortalURL({ ecommerceId })
  return response.data
}

export async function getInvoicedEcommerces(scope: {
  ecommerceId?: string
  group?: string
}) {
  const response = await billingApi.getInvoicedEcommerces(scope)
  return response.data
}
